@if (cis(); as cis) {
<p-dataView [layout]="'grid'" [value]="cis" [rows]="12" [paginator]="true" [alwaysShowPaginator]="false"
  [emptyMessage]="'Nessun allegato CIS presente'">
  @if (showHeader()) {
  <p-header>
    <div *hasClaim="GassClaims.DocModifica" class="flex">
      <button pButton type="button" class="scan" label="Aggiungi" title="Aggiungi" (click)="addCIS.emit()"
        icon="fas fa-plus" [disabled]="isLocked()"></button>
    </div>
  </p-header>
  }
  <ng-template let-cisallegati pTemplate="grid">
    <div class="grid">
      @for (cisallegato of cisallegati; track cisallegato.numeroOrdine) {
      <div class="col-2 cis" [class]="getItemClass(cisallegato)">
        <div class="grid">
          <div class="col-9 flex flex-column justify-content-center">
            <div class="col-12" style="text-align: center;">
              <i [class]="getCISIconClass(cisallegato.tipoCIS)" style="font-size: 2em;"></i>
            </div>
            <div class="col-12 cisname" [title]="cisallegato.tipoCIS">
              {{cisallegato.tipoCIS}}<br />
              @if (cisallegato.numeroCopie > 1) {
              ({{cisallegato.numeroCopie}} copie)
              }
              @else {
              &nbsp;
              }
            </div>
          </div>
          <div class="col-3">
            <div class="col-12">
              <div [class.isDisabled]="isDisabled(cisallegato)">
                <i class="side-text"
                  title="{{cisallegato.classifica}}">{{getClassificaSigla(cisallegato.classifica)}}</i>
              </div>
              <ng-container *hasClaim="GassClaims.DocModifica">
                <div (click)="onRestituisciCIS($event, cisallegato)" [class.isDisabled]="isDisabled(cisallegato)">
                  <i class="fas fa-reply side-icon" title="Restituisci"></i>
                </div>
                <div (click)="onModificaCIS($event, cisallegato)" [class.isDisabled]="isModifiedDisabled(cisallegato)">
                  <i class="fas fa-edit side-icon" title="Modifica"></i>
                </div>
                <div *ngIf="!isDisabled(cisallegato)" (click)="onDistruggiCIS($event, cisallegato)">
                  <i class="fas fa-trash-alt side-icon" title="Distruggi"></i>
                </div>
                <div *ngIf="showUndoDeleteAllegatoCIS(cisallegato)" (click)="onRecuperaCIS($event, cisallegato)" >
                  <i class="fas fa-fw fa-undo side-icon undo-color" title="Recupera"></i>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
      }
    </div>
  </ng-template>
</p-dataView>
}
